import { useState } from 'react';

import { APP_CONFIG } from '@/constants/app-config';
import { useTwin } from '@/lib/hooks/api/twin.hook';
import useUrlParams from '@/lib/hooks/useParams';
import { useSettingsStore, useTwinStore } from '@/store';
import { ContentLoader } from '../loaders/content-loader';
import { Avatar, AvatarFallback, AvatarImage } from '../ui/avatar';
import { Card, CardContent } from '../ui/card';

function AuthSectionImage() {
  const params = useUrlParams();

  const twinRedirect = params.get(APP_CONFIG.REDIRECT_URL_KEY);

  const twin =
    twinRedirect?.startsWith('/chat/') || twinRedirect?.startsWith('/t/')
      ? twinRedirect?.split('/')[2]
      : null;

  const { twin: savedTwin } = useTwinStore();

  const [isImageLoading, setIsImageLoading] = useState(true);

  const { twinData, isLoading, isRefetching } = useTwin(
    twin ?? (savedTwin?.name as string)
  );

  const { settings } = useSettingsStore();

  const coverImage = settings?.ui?.theming?.coverImage;

  const textColor = settings?.ui?.theming?.coverImageTextColor;

  const containerStyle = {
    backgroundImage: `url(${coverImage || null})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    color: textColor || null,
  };

  return (
    <Card
      className={!coverImage ? 'bg-muted text-secondary-foreground' : ''}
      style={coverImage ? containerStyle : null}
    >
      <CardContent className="flex flex-col h-full pt-6 items-center justify-center gap-4 lg:gap-8">
        {isLoading || isRefetching ? (
          <ContentLoader
            count={6}
            circles={1}
            circleSize={32}
            className="items-center"
          />
        ) : (
          <>
            <div className="flex flex-row-reverse md:flex-col justify-around gap-8 items-center ">
              <div className="flex flex-col md:items-center items-left justify-center text-left md:text-center">
                <h5 className="md:text-lg text-xs">Enter the world of</h5>
                <h5 className="md:text-xl text-sm">
                  virtual conversation with
                </h5>
                <h3 className="md:hidden inline-block md:text-3xl text-lg capitalize">
                  {twinData?.personalityName}
                </h3>
              </div>
              <Avatar className="w-[28vw] h-[30vw] sm:w-[24vw] sm:h-[28vw] lg:w-[20vw] lg:h-[22vw] xl:w-[18vw] xl:h-[20vw] rounded-xl border shadow-xl">
                <AvatarImage
                  src={twinData?.avatar}
                  alt=""
                  className={`object-cover object-top w-full h-full transition-opacity duration-500 ${
                    isImageLoading ? 'blur-md' : 'opacity-100'
                  }`}
                  onLoad={() => setIsImageLoading(false)}
                  onError={() => setIsImageLoading(false)}
                />
                <AvatarFallback className="rounded-md text-4xl">
                  {twinData?.personalityName?.slice(0, 1)}
                </AvatarFallback>
              </Avatar>
            </div>
            <div className="flex flex-col items-center justify-center gap-2">
              <h3 className="hidden md:inline-block md:text-4xl text-primary text-lg capitalize">
                {twinData?.personalityName}
              </h3>
              <div className="text-center w-full lg:w-3/4 text-sm md:text-base">
                {twinData?.description}
              </div>
            </div>
          </>
        )}
      </CardContent>
    </Card>
  );
}

export default AuthSectionImage;
